<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';

/* tools */
import {} from '@/scripts/utils';
import { gameSetup, onboardingBackground } from '@/scripts/computed';

export default {
  name: 'GamePlatform',
  components: {
    FullScreenOverlay,
    Button,
  },
  props: {
    activeGame: {
      required: true,
    },
    platform: {},
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'games']),
    gamePlatforms() {
      const { gameSetup } = this;

      if (!gameSetup) return [];

      const result = gameSetup.platforms;

      return result;
    },

    onboardingBackground,
    gameSetup,
  },
  created() {
    if (!this.activeGame)
      this.$router.push({
        name: 'Onboarding',
        params: { option: 'connect-game', errorState: true },
      });
  },
  mounted() {},
  methods: {
    ...mapActions({}),
  },
};
</script>

<template>
  <FullScreenOverlay
    :style="onboardingBackground"
    :class="{ shadowBg: onboardingBackground }"
  >
    <div class="onboarding">
      <div class="onboarding__top">
        <Button :back="true" class="back">
          <template #icon>
            <img :src="require(`@/assets/svg/arrow-left.svg`)" />
          </template>
        </Button>
      </div>
      <div class="onboarding__body">
        <div class="onboarding__row onboarding__row--head">
          <h1 class="onboarding__title">Please Select Your Platform</h1>
        </div>
        <div class="onboarding__row onboarding__row--list">
          <div class="list-btn">
            <!-- map -->
            <div
              class="list-btn__item"
              v-for="{ id, name, image } in gamePlatforms"
              :key="id"
              @click="$emit('change', id)"
            >
              <div :class="{ 'btn-game': true, 'is-active': platform === id }">
                <img :src="image.url" />
              </div>
            </div>
          </div>
        </div>
        <div class="onboarding__row onboarding__row--btn">
          <Button
            class="blue m-290"
            :disabled="!platform"
            @click="$emit('next')"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.onboarding {
  &__top {
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    text-transform: uppercase;
    color: #ffc800;
    text-align: center;
    margin: 0;
  }

  &__row {
    &--head + &--list {
      margin-top: 70px;
    }

    & + &--btn {
      margin-top: 50px;
    }

    &--btn {
      display: flex;
      justify-content: center;
    }
  }
}

.list-btn {
  display: flex;
  justify-content: center;
  width: 100%;

  &__item {
    width: 170px;

    & + & {
      margin-left: 30px;
    }
  }
}

.btn-game {
  width: 170px;
  height: 170px;
  border-radius: 12px;
  background-color: #1d2429;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.2s;
  border: 1px solid #1d2429;
  cursor: pointer;

  img {
    display: flex;
    max-width: 126px;
    max-height: 60px;
  }

  &:hover {
    border-color: rgba(47, 155, 137, 0.2);
  }

  &.is-active {
    border: solid 1px rgba(47, 155, 137, 0.2);

    &:before {
      opacity: 1;
      visibility: visible;
    }
  }

  &:before {
    content: '';
    border-bottom: 2px solid #38d5b8;
    border-left: 2px solid #38d5b8;
    width: 8px;
    height: 5px;
    position: absolute;
    transform: rotate(-45deg);
    top: 17px;
    right: 16px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s;
  }
}

@media (max-width: $mobile) {
  .onboarding {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    &__top {
      min-height: 29px;
      margin-bottom: 30px;
      flex-shrink: 0;
    }

    &__title {
      font-size: 24px;
      line-height: 1.28;
    }

    &__row {
      &--head + &--list {
        margin-top: 40px;
      }

      &--btn {
        flex-grow: 1;
        align-items: flex-end;
      }
    }
  }

  .list-btn {
    flex-wrap: wrap;

    &__item {
      width: 100%;
      display: flex;
      justify-content: center;

      & + & {
        margin-left: 0;
        margin-top: 15px;
      }
    }
  }

  .btn-game {
    width: 100%;
    max-width: 290px;
    height: 80px;

    img {
      max-height: 50px;
    }
  }
}
</style>
